var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsAttribute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.427 4.937.247.229 6.14 6.14a4.048 4.048 0 0 1 .251 5.45l-.045.048-.032.052-.174.198-7.467 7.467 3.264 3.263.38.41c.316.362.605.747.868 1.157l-.025-.025c.249.248.418.546.509.862.145.28.279.57.402.87l.212.568 2.799 8.38c.17.566.17 1.167-.026 1.868-.532 1.538-2.188 2.375-3.781 1.884l-8.311-2.764a10.337 10.337 0 0 1-1.619-.708 1.99 1.99 0 0 1-.553-.324 9.791 9.791 0 0 1-1.72-1.368l-3.257-3.257-7.474 7.475a4.054 4.054 0 0 1-5.454.218l-.257-.236-6.142-6.142c-1.52-1.524-1.595-3.909-.214-5.495l.23-.244 7.511-7.377-7.062-7.063-.29-.318a5.964 5.964 0 0 1 .375-8.095l2.36-2.34.198-.172.018-.014.086-.078c2.358-2.071 5.938-1.972 8.2.29l6.894 6.895L30.93 5.18a4.013 4.013 0 0 1 5.497-.243zM15.518 26.365l-7.541 7.407c-.013.012-.017.017-.008.029l6.163 6.165.036.016.036-.016 7.456-7.457-6.142-6.144zm22.13 7.976-3.33 3.329 4.996 1.662-1.667-4.991zM17.34 12.169l-5.182 5.18 4.626 4.625a2.02 2.02 0 0 1 .322.321l8.649 8.649a2.023 2.023 0 0 1 .3.302l4.515 4.516 5.18-5.181-.018-.02L17.34 12.168zm16.46-4.2-7.503 7.5 6.221 6.223 7.34-7.342.11-.127c.027-.026.035-.047.032-.065l-.014-.024-6.167-6.164h-.02zm-20.054.605c-.798-.797-2.051-.8-2.832-.02l-.162.14-2.227 2.21c-.68.67-.778 1.698-.323 2.42l.138.189.174.193.816.816 5.181-5.182z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAttribute);
export default __webpack_public_path__ + "static/media/icons-attribute.f078cd15694cf388621e6297be87b4e6.svg";
export { ForwardRef as ReactComponent };